import { FlowMachineContext } from '../state/flowMachine'
import { STEP } from '../@types/state'
import { getSkippedStepsByQueryParams } from './queryParamsHandler'
import { getAdditionalSkippedStepsForImmoverkauf24 } from './immoverkauf24Handler'
import { getSkippedStepsForEmbedJSCode } from './embedJSCodeHandler'

export const getFlowSkippedSteps = (ctx: FlowMachineContext): STEP[] => {
  return [
    ...getAdditionalSkippedStepsForImmoverkauf24(ctx),
    ...getSkippedStepsByQueryParams(ctx),
    ...getSkippedStepsForEmbedJSCode(),
  ]
}
